import { Row, Col, Form } from "antd";
import { ArrowRightOutlined } from "@ant-design/icons";
import { Input, Button, MaskedInput, Group, CirclesImage } from "@dreambigger/design-system/src/components";
import { Header, CodeVerification } from "../../components";
import styles from "../start.module.scss";
import { StartTemplateProps } from "./types";

export default function CirclesTemplate({
  assets,
  brand,
  flow,
  hideHeader,
  loginForm,
  keyByLoginMode,
  formattedCred,
  emailInputRef,
  phoneInputRef,
  handleNext,
  isAdminMode,
  codeVerificationProps,
}: StartTemplateProps) {
  const default_circles_img =
    "https://res.cloudinary.com/cotribute/image/upload/v1656016218/acquire/template_assets/circle-teal-1.png";

  return (
    <div className={`${styles.homePage} w-100 h-100 min-h-100vh`}>
      {!hideHeader && <Header brand={brand} />}

      <Group
        className={`w-100 pv-8 reverse flex-column-reverse lg_flex-row min-h-60vh lg_mv-4 tc lg_tl pa-4 md_ph-11vw br-2`}
        style={{
          background: assets.heroBackground
            ? `url(${assets.heroBackground})`
            : `linear-gradient(180deg, rgba(${
                assets.heroBackgroundColor1 || "235, 236, 237"
              }) 0%, rgba(${
                assets.heroBackgroundColor2 || "235, 236, 237"
              }) 100%)`,
        }}
      >
        {/* LEFT COLUMN */}
        <div className="w-100 lg_w-50">
          <div className="flex flex-column w-100 lg_w-90 lg">
            <span
              className={`textSecondary mb-5 lh-1 f-8 xl_f-9 xxl_f-10 fwt mt-7 lg_mt-0`}
              dangerouslySetInnerHTML={{
                __html: assets.title ?? "",
              }}
            ></span>
            <span
              className={`textSecondary f-5 md_f-7 xl_f-8 xxl_f-9 mb-6 lh-1`}
              dangerouslySetInnerHTML={{
                __html: assets.subTitle ?? "",
              }}
            />
            <span
              className={`textSecondary f-4 md_f-5 xl_f-6 xxl_f-7 lh-2`}
              dangerouslySetInnerHTML={{
                __html: assets.description ?? "",
              }}
            />
          </div>
          <Form
            form={loginForm}
            className="mv-5"
            initialValues={{ [keyByLoginMode]: formattedCred }}
            onFinish={handleNext}
          >
            <label
              className="textSecondary fwb f-6 lg_f-4 xl_f-5 xxl_f-6"
              dangerouslySetInnerHTML={{
                __html: assets.loginTitle ?? "",
              }}
            />
            <Row
              align="bottom"
              className="mt-1 mb-8 fwb justify-center lg_justify-start"
            >
              <Form.Item name={keyByLoginMode} className="mr-1">
                {flow.financialInstitution.loginMode === "email" ? (
                  <Input
                    className={`br-5 pa-3 mt-3 md_mt-0 ${
                      isAdminMode && "disabled notAllowed"
                    }`}
                    style={{ borderColor: "black", width: "317px" }}
                    placeholder={assets.loginPlaceholder}
                    type="email"
                    ref={emailInputRef}
                    readOnly={isAdminMode}
                    required
                  />
                ) : (
                  <MaskedInput
                    className={`br-5 pa-3 mt-3 md_mt-0 ${
                      isAdminMode && "disabled notAllowed"
                    }`}
                    placeholder={assets.loginPlaceholder}
                    mask="(000) 000-0000"
                    name="phone"
                    ref={phoneInputRef}
                    readOnly={isAdminMode}
                  />
                )}
              </Form.Item>

              <div
                className="min-w-20"
                style={{ paddingLeft: "8px", paddingRight: "8px" }}
              >
                <Form.Item>
                  <Button
                    type="primary"
                    htmlType="submit"
                    className="lift h-8 pr-6"
                  >
                    {assets.submitButtonText} <ArrowRightOutlined />
                  </Button>
                </Form.Item>
              </div>
            </Row>
          </Form>

          <Col className="w-100 lg_w-90">
            <div
              className="textSecondary fwt f-4 xl_f-5 xxl_f-6"
              dangerouslySetInnerHTML={{
                __html: assets.landingTermsTitle ?? "",
              }}
            />
            <div
              className={`${styles.terms} textSecondary f-3 xl_f-4 xxl_f-5`}
              dangerouslySetInnerHTML={{
                __html: assets.landingTermsText ?? "",
              }}
            />
          </Col>
        </div>

        {/* RIGHT COLUMN */}
        {assets.accentColor1 || assets.accentColor2 ? (
          <CirclesImage
            src={assets.heroImage}
            accentColor1={assets.accentColor1 || brand.primaryColor}
            accentColor2={assets.accentColor2 || brand.secondaryColor}
            className="w-100 lg_w-50 pb-100 lg_pa-0"
            style={{ maxWidth: "750px" }}
          />
        ) : (
          <div className="w-100 lg_w-50">
            <img
              className="w-100"
              style={{ maxWidth: "750px" }}
              src={assets.heroImage || default_circles_img}
            />
          </div>
        )}
      </Group>
      <CodeVerification {...codeVerificationProps} />
    </div>
  );
}
